import { render, staticRenderFns } from "./BroadcastMessageModal.vue?vue&type=template&id=9c5ffdc6&"
import script from "./BroadcastMessageModal.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports